import Component from 'component';
import VanillaModal from 'vanilla-modal';
import _template from 'lodash/template';
import _debounce from 'lodash/debounce';
import ytTpl from '../templates/youtube';
import vimeoTpl from '../templates/vimeo';

const leftArrow =
  '<img src="/dist/sites/pg/images/icons/icon-arrow-left.svg" alt="prev slide">';
const rightArrow =
  '<img src="/dist/sites/pg/images/icons/icon-arrow-right.svg" alt="prev slide">';

class SwatchGallery extends Component {
  setupDefaults() {
    this.dom = {
      $previews: this.$el.find('.swatch-gallery-preview__slider'),
      $previewTrigger: this.$el.find('.swatch-gallery-swatch__button'),
      $modalTrigger: this.$el.find('.swatch-gallery-preview__modal-trigger'),
      $slides: this.$el.find('.swatch-gallery-modal__slider'),
      $modalCloseTrigger: this.$el.find('.btn-close--modal'),
      $modalHolder: this.$el.find('.swatch-gallery-modal-holder')
    };

    this.initPreviews();
    this.setImageHeight();
    this.modal = new VanillaModal({
      onOpen: ::this.onModalOpen,
      onBeforeClose: ::this.onModalClose,
      clickOutside: true,
      'class': 'modal-open'
    });

    this.index = 0;
  }

  addListeners() {
    this.dom.$modalTrigger.on('click', ::this.onModalTriggerClick);
    this.dom.$previewTrigger.on('click', ::this.updatePreview);
    this.dom.$modalCloseTrigger.on('click', () => this.modal.close());
    $(window).on('tabChange', () => this.previews.slick('refresh'));
    $(window).on('resize', _debounce(::this.setImageHeight, 100));
  }

  setImageHeight() {
    let maxHeight = 0;
    this.dom.$previewTrigger.height('auto');
    this.dom.$previewTrigger.each((i, el) => {
      if ($(el).height() > maxHeight) {
        maxHeight = $(el).height();
      }
    });

    this.dom.$previewTrigger.height(maxHeight);
  }

  onModalTriggerClick(e) {
    const index = $(e.currentTarget)
      .closest('.slick-slide')
      .attr('data-slick-index');
    const id = this.dom.$modalHolder.attr('id');
    this.index = parseInt(index);

    this.modal.open(`#${id}`);
  }

  onModalOpen(e, j) {
    this.slider = this.dom.$slides
      .on('init', () => this.handleVideo(this.index))
      .slick({
        infinite: false,
        dots: false,
        initialSlide: this.index,
        prevArrow: `<button aria-label="Prev slide" class="slick-prev slick-arrow">${leftArrow}</button>`,
        nextArrow: `<button aria-label="Next slide" class="slick-next slick-arrow">${rightArrow}</button>`
      })
      .on('beforeChange', (e, slick, current, next) => {
        this.index = next;

        this.resetVideo(current);
        this.handleVideo(next);
      });
  }

  onModalClose() {
    this.resetVideo(this.index);
    this.slider.slick('unslick');
  }

  initPreviews() {
    this.previews = this.dom.$previews.slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      fade: true
    });
  }

  updatePreview(e) {
    this.index = $(e.currentTarget).parent().index();

    if (window.matchMedia('(max-width: 639px)').matches) {
      const modalId = this.dom.$modalHolder.attr('id');
      this.modal.open(`#${modalId}`);
      return;
    }

    this.previews.slick('slickGoTo', this.index);
  }

  handleVideo(slide) {
    const $slide = this.dom.$slides.find(`[data-slick-index=${slide}]`);
    const isVideo = !!$slide.data('videoId');
    if (!isVideo) return;

    this.playVideo($slide);
  }

  playVideo($slide) {
    const id = $slide.data('videoId');
    const type = $slide.data('videoType');
    const html = this.getVideoContent(id, type);
    $slide.find('.swatch-gallery-modal__image').html(html);
  }

  getVideoContent(id, type) {
    let templateFn;
    switch (type) {
    case 'youtube':
      templateFn = _template(ytTpl);
      break;
    case 'vimeo':
      templateFn = _template(vimeoTpl);
      break;

    default:
      break;
    }

    return templateFn({ videoId: id, title: '' });
  }

  resetVideo(slide) {
    const $slide = this.dom.$slides.find(`[data-slick-index=${slide}]`);
    $slide.find('.swatch-gallery-modal__image').empty();
  }
}

export default SwatchGallery;



// WEBPACK FOOTER //
// ./src/pg/js/components/SwatchGallery.js